<template>
  <div class="h-screen w-full flex items-center justify-center" v-if="loading">
    <splash />
  </div>
  <div
    class="w-full h-screen grid overflow-hidden"
    :class="[!headerVisible ? 'grid-rows-1-auto' : 'grid-rows-auto-1-auto']"
    id="app-inner"
    v-else
  >
    <wd-header v-if="headerVisible" />
    <main class="bg-gray-100 overflow-hidden overflow-y-auto">
      <router-view />
    </main>
    <wd-footer v-if="footerVisible" />
    <modals />
    <div v-if="celebrations.length > 0">
      <celebration
        v-for="celebration in celebrations"
        :key="celebration.id"
        :celebration="celebration"
      />
    </div>
    <popups />
  </div>
</template>

<script>
const Popups = require("@/modules/popups/components/Popups.vue").default;
const WdHeader = require("@/modules/header/components/WdHeader.vue").default;
const WdFooter = require("@/modules/footer/components/WdFooter.vue").default;
const Modals = require("@/modules/modals/components/Modals.vue").default;
const Splash = require("@/modules/core/components/Splash.vue").default;
const Celebration = require("@/modules/core/components/Celebration.vue")
  .default;

export default {
  name: "app",
  data() {
    return {
      loading: true
    };
  },
  components: {
    Popups,
    WdHeader,
    WdFooter,
    Modals,
    Splash,
    Celebration
  },
  methods: {},
  computed: {
    logged() {
      return this.$store.getters["auth/logged"];
    },
    celebrations() {
      return this.$store.getters["notification/celebrations"];
    },
    routeMeta() {
      return this.$route.meta;
    },
    headerVisible() {
      return this.routeMeta.header !== undefined ? this.routeMeta.header : true;
    },
    footerVisible() {
      return this.routeMeta.footer !== undefined ? this.routeMeta.footer : true;
    },
    fontSize() {
      let fontSize;
      let size = this.$store.getters["auth/fontSize"];
      switch (size) {
        case "default":
          fontSize = "16px";
          break;
        case "lg":
          fontSize = "20px";
          break;
        case "xl":
          fontSize = "22px";
          break;

        default:
          fontSize = "16px";
          break;
      }
      return fontSize;
    }
  },
  created() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    window.addEventListener("resize", () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
  },
  async mounted() {
    switch (process.env.NODE_ENV) {
      case "development":
      case "dev":
      case "local":
        console.groupCollapsed("[DEBUG]: WD CLIENT DEBUG INFORMATION");
        console.table(process.env);
        console.info(this.$store.getters);
        console.groupEnd();
        break;
    }

    this.$store.dispatch("header/reset");
    await new Promise(resolve => setTimeout(resolve, 2000));

    this.loading = false;
  },
  watch: {
    fontSize(newVal) {
      document.documentElement.style.fontSize = newVal;
    }
  }
};
</script>
<style  scoped>
#app-inner {
  height: calc(var(--vh, 1vh) * 100);
}
</style>